import React, { useState, useEffect, useContext, useRef, useMemo, useCallback } from 'react';
import { Route, Routes, Navigate, useLocation } from 'react-router-dom'
import { message, Divider, Table, Pagination, Row, Col, InputNumber, Radio, Button, Spin, Tabs, Tag, Space } from 'antd';
import API from '@api/api.js';
import styles from './index.module.scss'
import { AppContext } from '@utils/AppContext';
import eventBus from '@utils/eventBus';
import UpdatePasswordModal from '@view/compoents/personalCenterModal/updatePasswordModal'
import PSAIModal from "@PSAIComponents/PSAIModal";
import QRCode from 'qrcode.react'
import Payment from '@view/compoents/Payment';
import dayjs from 'dayjs';
import JSZip from 'jszip';
import XLSX from "xlsx";
import XLSXStyle from "xlsx-style";

// 结算记录详情
const BillDetailView = (props) => {
    const { dataSource, demandTags } = props
    const columns = useMemo(() => [{
        title: '客户名称',
        dataIndex: 'merchantName',
        key: 'merchantName',
        width: 200,
        onCell: (record, index) => ({
            rowSpan: record.rowSpan,
        }),
    }, {
        title: '交付批次',
        dataIndex: 'deliveryVersion',
        key: 'deliveryVersion',
        width: 200,
        onCell: (record, index) => ({
            rowSpan: record.rowSpan,
        }),
    }, {
        key: 'projectType',
        title: '项目类型',
        dataIndex: 'projectType',
        width: 150,
        hidden: true,
        render: text => text == 0 ? "免费POC" : text == 1 ? "交付" : text == 2 ? "付费POC" : text,
        onCell: (record, index) => ({
            rowSpan: record.rowSpan,
        }),
    }, {
        title: '完结日期',
        dataIndex: 'completedTime',
        key: 'completedTime',
        width: 150,
        render: text => text ? dayjs(text).format("YYYY-MM-DD") : "",
        onCell: (record, index) => ({
            rowSpan: record.rowSpan,
        }),
    }, {
        key: "demandItems",
        title: "服务内容",
        dataIndex: "demandItems", 
        width: 300,
        render: text => text.map(item => {
            const demand = demandTags.find(tag => tag.value == item.demandId)
            return `${demand?.label || "综合服务"}`
        }).join("、"),
    }, {
        key: "deductAmount",
        title: "图片单价",
        dataIndex: "deductAmount", 
        width: 150,
        render: text => `￥${text}`
    }, {
        key: "waitPayCount",
        title: "结算数量",
        dataIndex: "waitPayCount",
        width: 150,
    }, {
        key: "checkoutTotal",
        title: "结算金额",
        dataIndex: "checkoutTotal",
        width: 150,
        render: text => `${text}元`,
    }, {
        key: "totalWaitPayCount",
        title: "总结算数量",
        dataIndex: "totalWaitPayCount",
        width: 150,
        onCell: (record, index) => ({
            rowSpan: record.rowSpan,
        }),
    }, {
        key: "urgentNum",
        title: "加急数量",
        dataIndex: "urgentNum",
        width: 150,
        onCell: (record, index) => ({
            rowSpan: record.rowSpan,
        }),
    }, {
        key: "guideAmount",
        title: "指导价(含税)",
        dataIndex: "guideAmount",
        width: 150,
        render: (_, record) => `${record.guideAmount}元`,
        onCell: (record, index) => ({
            rowSpan: record.rowSpan,
        }),
    }, {
        key: "totalCheckoutTotalEditable",
        title: "实付价(含税)",
        dataIndex: "totalCheckoutTotalEditable",
        width: 150,
        render: (_, record) => record.updated ? `${record.totalCheckoutTotalEditable}元` : `${record.totalCheckoutTotal}元`,
        onCell: (record, index) => ({
            rowSpan: record.rowSpan,
        }),
    }, {
        key: "remark",
        title: "备注",
        dataIndex: "remark",
        width: 200,
        onCell: (record, index) => ({
            rowSpan: record.rowSpan,
        }),
    }].map(col => {
        if (!col.editable) return col
        return {
            ...col,
            onCell: record => {
                const cellObj = col.onCell?.(record) || {}
                return {
                    ...cellObj,
                    record,
                    editable: true,
                    dataIndex: col.dataIndex,
                }
            }
        }
    }), [demandTags])
    useEffect(() => {
        console.log('dataSource', dataSource)
    }, [dataSource])
    return (
        <div className={styles.BillDetailView}>
            <div className={styles.BillDetailTable}>
                <Table
                    rowKey={"rowKey"}
                    className="customTable"
                    dataSource={dataSource}
                    columns={columns}
                    pagination={false}
                    scroll={{
                        x: 'max-content',
                        y: `max-content`,
                    }}
                />
            </div>
        </div>
    )
}

export default BillDetailView
